import Global from '@Global';
import AddSuffix from '@Utils/Number/AddSuffix';
import Network from '@Networks/Localhost';

/**
 * Leaderboard Entry
 */
class LeaderboardEntry
{
    private scene: Phaser.Scene;

    private index: number;
    private x: number;
    private y: number;

    private leaderboardEntry: Networks.LeaderboardEntry;

    /*----------------- Player Data ------------------------*/
    private playerImageMask: Phaser.GameObjects.Graphics;
    private playerImage: Phaser.GameObjects.Image;
    private playerRankText: Phaser.GameObjects.Text;
    private playerNameText: Phaser.GameObjects.Text;
    private playerScoreText: Phaser.GameObjects.Text;

    /**
    * Constructor
     * @param scene
     * @param index
     * @param leaderboardEntryData
     */
    constructor(scene:Phaser.Scene, index:number , leaderboardEntry: Networks.LeaderboardEntry)
    {
        this.index = index;
        this.scene = scene;
        this.leaderboardEntry = leaderboardEntry;

        this.x = 250;
        this.y = 170 + (index * 57);

        this.createPlayerIndicator();
        this.createRankText();
        this.createPlayerImage();
        this.createPlayerName();
        this.createPlayerScore();
        this.startTransition();

        Global.leaderboardEntry = this;
    }

    /**
     * Create player indicator
     */
    private createPlayerIndicator()
    {
        const leaderboardPlayerID = this.leaderboardEntry.getPlayer().getID();
        const currentPlayerID = Network.player.getID();

        if( leaderboardPlayerID === currentPlayerID )
        {
            const indicator = this.scene.add.graphics();
            indicator.fillStyle(0x00000);
            indicator.beginPath();
            indicator.lineTo(0,0);
            indicator.lineTo(0,20);
            indicator.lineTo(20,10);
            indicator.closePath();
            indicator.fillPath();
            indicator.y = this.y + 20;
            indicator.x = this.x - 60;
            indicator.alpha = 0;

            const transitionDelay = this.index * 300;

            this.scene.add.tween({ targets: indicator, y: this.y + 5, alpha: 1, duration: 300, delay: transitionDelay });
        }
    }

    /**
     * Creates rank text
     */
    private createRankText()
    {
        const fontStyle = { fontFamily: 'Permanent Marker', color: '#000000', fontSize: '25px', align:'right' };

        const playerRankText = this.scene.add.text(this.x + 40, 0 + this.y, AddSuffix(this.leaderboardEntry.getRank()), fontStyle);
        playerRankText.setOrigin(1, 0);

        this.playerRankText = playerRankText;
    }

    /**
     * Creates player image
     */
    private createPlayerImage()
    {
        const player = this.leaderboardEntry.getPlayer();

        const playerID = player.getID();
        const playerTextureKey = `player-${playerID}`;

        const playerImagePositionX = this.x + 85;
        const playerImagePositionY = this.y + 15;

        /**
         * Player image circle mask
         */
        const circleMask = this.scene.add.graphics();
        circleMask.fillStyle(0xffffff);
        circleMask.fillCircle(0, 0, 25);
        circleMask.setX(playerImagePositionX)
        circleMask.setY(playerImagePositionY);
        circleMask.setInteractive();

        this.playerImageMask = circleMask;

        /**
         * Create Player Image
         */
        const playerImage = this.scene.add.image(playerImagePositionX, playerImagePositionY, playerTextureKey);
        playerImage.setMask(circleMask.createGeometryMask());
        playerImage.setOrigin(0.5);
        playerImage.setDisplaySize(80, 80);

        this.playerImage = playerImage;
    }

    /**
     * Creates player name
     */
    private createPlayerName()
    {
        const player = this.leaderboardEntry.getPlayer();

        this.playerNameText = this.scene.add.text(this.x + 140, 0 + this.y, player.getName(), {
            fontFamily: 'Permanent Marker',
            color: '#000000',
            fontSize: '25px'
        });
    }

    /**
     * Create player score
     */
    private createPlayerScore()
    {
        const scoreText = this.scene.add.text(this.x + 520, 0 + this.y, this.leaderboardEntry.getFormattedScore(), {
            fontFamily: 'Permanent Marker',
            color: '#000000',
            fontSize: '25px'
        });
        scoreText.setAlign('right');
        scoreText.setOrigin(1, 0);
        this.playerScoreText = scoreText;
    }

    /**
     * Starts transition
     */
    private startTransition()
    {
        const transitionDelay = this.index * 300;

        const leaderboardEntryObjects = [
            this.playerRankText,
            this.playerNameText,
            this.playerScoreText,
        ];

        const playerImageObjects = [
            this.playerImageMask,
            this.playerImage,
        ];

        Phaser.Actions.SetAlpha([...leaderboardEntryObjects, ...playerImageObjects], 0);
        Phaser.Actions.SetY(leaderboardEntryObjects, this.y + 15);
        Phaser.Actions.SetY(playerImageObjects, this.y + 30);

        this.scene.add.tween({ targets: leaderboardEntryObjects, y: this.y, alpha: 1, duration: 300, delay: transitionDelay });
        this.scene.add.tween({ targets: playerImageObjects, y: this.y + 15, alpha: 1, duration: 300, delay: transitionDelay });
    }

}

export default LeaderboardEntry;